/* Крашу элемент в цвет из data-атрибута */

$('[data-colored]').each(function() {
    let $currEl = $(this);
    let elColor = $currEl.data('color');

    $currEl[0].style.cssText = `--color: ${elColor};`;
});



// WEBPACK FOOTER //
// ./_src/js/Colors.js